import angular from 'angular';
import angularRoute from 'angular-route';

import auth from '../auth/auth-module';
import forms from '../forms/forms-module';
import data from '../data/data-module';

import LoginCtrl from './login-ctrl';
import routes from './login-routes';
import cascadedParamExtractor from './cascaded-param-extractor';

export default angular.module('login', [angularRoute, auth, forms, data])
    .service('cascadedParamExtractor', cascadedParamExtractor)
    .controller('LoginCtrl', LoginCtrl)
    .config(routes)
    .name;



// WEBPACK FOOTER //
// ./login/login-module.js